import { Platform } from '../types';
import { withAuthAnalytics } from './analytics';
import { createCapacitorIdentityProvider } from './capacitor';
import { createDiscordIdentityProvider } from './discord';
import { createTauriIdentityProvider } from './tauri';
import type { IdentityProvider } from './types';
import { createWebIdentityProvider } from './web';

const buildProvider = (platform: Platform, apiBaseUrl: string): IdentityProvider => {
  switch (platform) {
    case Platform.Discord:
      return createDiscordIdentityProvider(apiBaseUrl);
    case Platform.Tauri:
      return createTauriIdentityProvider(apiBaseUrl);
    case Platform.Capacitor:
      return createCapacitorIdentityProvider(apiBaseUrl);
    case Platform.Web:
      return createWebIdentityProvider(apiBaseUrl);
  }
};

/**
 * Build the identity provider matching the active platform. Each call
 * constructs a fresh provider bound to the supplied API base URL — there is
 * no module-scoped singleton, so tests can build per-platform providers
 * independently and `PlatformProvider` can rebuild on a (rare) platform
 * switch.
 *
 * The provider is wrapped with the analytics decorator so every
 * acquire / restore / clear emits the corresponding `auth.*` Forge events.
 */
export const getIdentityProvider = (platform: Platform, apiBaseUrl: string): IdentityProvider =>
  withAuthAnalytics(buildProvider(platform, apiBaseUrl));

export type { Identity, IdentityAcquireRequest, IdentityProvider } from './types';
